import { IconButtonProps } from './props'
import { StyledIconButton } from './styles'
import Text from '../Text'
import { forwardRef } from 'react'

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
    ({ icon, title, ...props }, ref) => (
        <StyledIconButton {...props} ref={ref}>
            {icon}
            {title && (
                <Text bold css={{ lineHeight: 1 }} size="s">
                    {title}
                </Text>
            )}
        </StyledIconButton>
    )
)

IconButton.displayName = 'IconButton'

export default IconButton

export { StyledIconButton }
